import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import './WorldCup.css';

const API = '/api';

// Strip title sponsors and shorten 'Grand Prix' -> 'GP'
const f1Name = (s='') => s
  .replace(/^(MSC Cruises|Lenovo|Pirelli|Heineken|Qatar Airways|Aramco|Rolex|Gulf Air|STC|Crypto\.com|Louis Vuitton|MSC|Etihad Airways|AWS|DHL|Singapore Airlines)\s+/i,'')
  .replace(/grand prix/i,'GP').trim();

const SPORT_FILTERS = [
  {key:'all',label:'All'},{key:'soccer',label:'Soccer'},{key:'nba',label:'NBA'},
  {key:'nfl',label:'NFL'},{key:'mlb',label:'MLB'},{key:'ncaa',label:'NCAA'},
  {key:'f1',label:'F1'},{key:'ufc',label:'UFC'},
];

const SOCCER_KW = ['brasileirão','premier','la liga','bundesliga','serie a','ligue',
  'champions','libertadores','sudamericana','world cup','international friendly','friendly'];

const leagueToFilter = (league='') => {
  const l = league.toLowerCase();
  if (SOCCER_KW.some(k=>l.includes(k))) return 'soccer';
  if (l.includes('nba')) return 'nba';
  if (l.includes('nfl')) return 'nfl';
  if (l.includes('mlb')) return 'mlb';
  if (l.includes('ncaa')||l.includes('college')) return 'ncaa';
  if (l.includes('formula')||l.includes('f1')||l.includes('grand prix')||l.includes(' gp ')||l.includes('gp ·')) return 'f1';
  if (l.includes('ufc')||l.includes('mma')) return 'ufc';
  return 'other';
};

const leagueToKey = (league='') => {
  const l = league.toLowerCase();
  if (l.includes('premier')) return 'epl';
  if (l.includes('brasileirão')||l.includes('brasileiro')) return 'brasileirao';
  if (l.includes('champions')) return 'ucl';
  if (l.includes('libertadores')) return 'libertadores';
  if (l.includes('sudamericana')||l.includes('sulamericana')) return 'sulamericana';
  if (l.includes('la liga')) return 'laliga';
  if (l.includes('bundesliga')) return 'bundesliga';
  if (l.includes('serie a')) return 'serie_a';
  if (l.includes('ligue')) return 'ligue1';
  if (l.includes('world cup')) return 'world_cup_q';
  if (l.includes('nfl')) return 'nfl';
  if (l.includes('college')||l.includes('ncaa')) return 'ncaa_fb';
  if (l.includes('nba')) return 'nba';
  if (l.includes('mlb')) return 'mlb';
  if (l.includes('formula')||l.includes('f1')||l.includes('grand prix')||l.includes(' gp ')||l.includes('gp ·')) return 'f1';
  if (l.includes('ufc')||l.includes('mma')) return 'ufc';
  if (l.includes('friendly')) return 'friendly';
  return null;
};

const SPORT_ORDER = ['soccer','nba','nfl','mlb','ncaa','f1','ufc','other'];
const SPORT_LABELS = {
  soccer:'⚽ Soccer',nba:'🏀 NBA',nfl:'🏈 NFL',mlb:'⚾ MLB',
  ncaa:'🏈 NCAA',f1:'🏎 Formula 1',ufc:'🥊 UFC',other:'🏅 Other',
};
const SPORT_ICONS = {nfl:'🏈',ncaa:'🏈',nba:'🏀',mlb:'⚾',f1:'🏎',ufc:'🥊'};

const LEAGUE_LOGOS = {
  nfl:         'https://a.espncdn.com/i/teamlogos/leagues/500/nfl.png',
  nba:         'https://a.espncdn.com/i/teamlogos/leagues/500/nba.png',
  mlb:         'https://a.espncdn.com/i/teamlogos/leagues/500/mlb.png',
  ncaa_fb:     'https://a.espncdn.com/i/teamlogos/leagues/500/ncaa.png',
  f1:          'https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/F1.svg/120px-F1.svg.png',
  ufc:         'https://a.espncdn.com/i/teamlogos/leagues/500/ufc.png',
  epl:         'https://a.espncdn.com/i/leaguelogos/soccer/500/23.png',
  laliga:      'https://a.espncdn.com/i/leaguelogos/soccer/500/15.png',
  bundesliga:  'https://a.espncdn.com/i/leaguelogos/soccer/500/10.png',
  serie_a:     'https://a.espncdn.com/i/leaguelogos/soccer/500/12.png',
  ligue1:      'https://a.espncdn.com/i/leaguelogos/soccer/500/9.png',
  ucl:         'https://a.espncdn.com/i/leaguelogos/soccer/500/2.png',
  libertadores:'https://a.espncdn.com/i/leaguelogos/soccer/500/58.png',
  sulamericana:'https://a.espncdn.com/i/leaguelogos/soccer/500/1208.png',
  brasileirao: 'https://a.espncdn.com/i/leaguelogos/soccer/500/85.png',
  world_cup_q: 'https://flagcdn.com/w40/un.png',
  friendly:    'https://flagcdn.com/w40/un.png',
};

const TEAM_COLORS = {
  corinthians:{primary:'#111',secondary:'#e8e0cc',accent:'#e8e0cc',badge:'⚫',
    logo:'https://a.espncdn.com/i/teamlogos/soccer/500/874.png'},
  lakers:     {primary:'#2a1060',secondary:'#FDB927',accent:'#FDB927',badge:'🟣',
    logo:'https://a.espncdn.com/i/teamlogos/nba/500/lal.png'},
  dodgers:    {primary:'#001f6b',secondary:'#ffffff',accent:'#EF3E42',badge:'🔵',
    logo:'https://a.espncdn.com/i/teamlogos/mlb/500/lad.png'},
  patriots:   {primary:'#001a3d',secondary:'#C60C30',accent:'#C60C30',badge:'🔴',
    logo:'https://a.espncdn.com/i/teamlogos/nfl/500/ne.png'},
  brazil_nt:  {primary:'#005c20',secondary:'#FFDF00',accent:'#FFDF00',badge:'🟢',
    logo:'https://flagcdn.com/w80/br.png'},
  f1:         {primary:'#3a0000',secondary:'#ff4444',accent:'#e8002d',badge:'🏎',
    logo:'https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/F1.svg/120px-F1.svg.png'},
  ufc:        {primary:'#1a0000',secondary:'#ff6666',accent:'#c0392b',badge:'🥊',
    logo:'https://a.espncdn.com/i/teamlogos/leagues/500/ufc.png'},
  ucla:       {primary:'#0a1f4a',secondary:'#F2A900',accent:'#F2A900',badge:'🔷',
    logo:'https://a.espncdn.com/i/teamlogos/ncaa/500/26.png'},
};

const MY_TEAMS = [
  {key:'corinthians',name:'Corinthians',sport:'soccer'},
  {key:'lakers',     name:'Lakers',     sport:'nba'},
  {key:'dodgers',    name:'Dodgers',    sport:'mlb'},
  {key:'patriots',   name:'Patriots',   sport:'nfl'},
  {key:'brazil_nt',  name:'Brazil',     sport:'soccer'},
  {key:'f1',         name:'Ferrari/F1', sport:'f1'},
  {key:'ufc',        name:'UFC',        sport:'ufc'},
  {key:'ucla',       name:'UCLA',       sport:'ncaa'},
];

const SEASON_MONTHS = {
  soccer:[1,2,3,4,5,6,7,8,9,10,11,12],
  mlb:[4,5,6,7,8,9,10],
  nfl:[9,10,11,12,1,2],
  ncaa:[8,9,10,11,12,1],
  nba:[10,11,12,1,2,3,4,5,6],
  f1:[3,4,5,6,7,8,9,10,11],
  ufc:[1,2,3,4,5,6,7,8,9,10,11,12],
};

const isInSeason = (sport) => {
  const month = new Date().getMonth()+1;
  return (SEASON_MONTHS[sport]||[]).includes(month);
};



// ── Sound engine ─────────────────────────────────────────────────────────────
const _soundQueue = [];
let _soundPlaying = false;

function _playNext() {
  if (_soundPlaying || _soundQueue.length === 0) return;
  const src = _soundQueue.shift();
  _soundPlaying = true;
  const audio = new Audio(src);
  audio.volume = 0.8;
  audio.onended = () => { _soundPlaying = false; _playNext(); };
  audio.onerror = () => { _soundPlaying = false; _playNext(); };
  audio.play().catch(() => { _soundPlaying = false; _playNext(); });
}

function queueSound(src) {
  _soundQueue.push(src);
  _playNext();
}

// ── Sound helpers ─────────────────────────────────────────────────────────────
function pickRandom(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

// ── Team sound configs ────────────────────────────────────────────────────────
const TEAM_SOUNDS = {
  corinthians: {
    search:      ['corinthians'],
    base:        '/sounds/corinthians/',
    onLive:      'hino-corinthians-cantado.mp3',
    onScore:     'qui-fase-que-ta-o-curintia.mp3',
    onConcede:   'se-o-corinthians-nao-ganhar-ole-ole-ola.mp3',
    skipGeneric: true, // has its own win/lose sounds
  },
  dodgers: {
    search: ['dodgers', 'los angeles dodgers'],
    base:   '/sounds/dodgers/',
    onLive:  'baseball-classic-charge-123.mp3',
    onScore: 'homerun-baseball.mp3',
  },
  brazil: {
    search: ['brazil', 'brasil'],
    base:   '/sounds/brazil/',
    onLive: 'senna-theme.mp3',
  },
  lakers:    { search: ['lakers',   'los angeles lakers'],    base: '/sounds/generic/' },
  patriots:  { search: ['patriots', 'new england patriots'],  base: '/sounds/generic/' },
  ucla:      { search: ['ucla',     'ucla bruins'],           base: '/sounds/generic/' },
};

// Randomized win/lose sounds for non-Corinthians teams (files in /sounds/generic/)
const GENERIC_WIN_SOUNDS = [
  '/sounds/generic/victory_fanfare.mp3',
  '/sounds/generic/street-fighter-ii-you-win-perfect.mp3',
  '/sounds/generic/victory-mario-series-hq-super-smash-bros.mp3',
  '/sounds/generic/victoryff.mp3',
  '/sounds/generic/victoryscreech.mp3',
];
const GENERIC_LOSE_SOUNDS = [
  '/sounds/generic/miau-triste.mp3',
  '/sounds/generic/tmpq7mpzzl9.mp3',
];

// Teams whose loss triggers a rival celebration
const RIVAL_SOUNDS = [
  { search: ['santos','sao paulo','são paulo','flamengo'], sound: '/sounds/corinthians/cropcruzeiro.mp3' },
  { search: ['palmeiras'],                                  sound: '/sounds/corinthians/chupaa-palmeras-full.mp3' },
];

// ── Score tracker ─────────────────────────────────────────────────────────────
const _prevScores = {};
const _rivalSeen  = {};

function checkScoreChanges(games){
  if(!games) return;

  // ── Fav team games (live) ──
  games.filter(g=>g.state==='in').forEach(g=>{
    const key = g.id;
    const hs = parseInt(g.home_score)||0;
    const as = parseInt(g.away_score)||0;
    const prev = _prevScores[key];

    // Match to a team sound config
    let sounds = null;
    let favIsHome = false;
    for(const [, ts] of Object.entries(TEAM_SOUNDS)){
      const search = ts.search || [];
      const hm = search.some(s=>g.home?.toLowerCase().includes(s));
      const am = search.some(s=>g.away?.toLowerCase().includes(s));
      if(hm||am){ sounds=ts; favIsHome=hm; break; }
    }

    if(!prev){
      if(sounds && !_prevScores[key+'_announced']){
        queueSound(sounds.base + sounds.onLive);
        _prevScores[key+'_announced'] = true;
      }
      _prevScores[key] = {hs, as};
      return;
    }

    if(sounds){
      const favScore = favIsHome ? hs : as;
      const oppScore = favIsHome ? as : hs;
      const prevFav  = favIsHome ? prev.hs : prev.as;
      const prevOpp  = favIsHome ? prev.as : prev.hs;
      if(favScore > prevFav)  queueSound(sounds.base + sounds.onScore);
      else if(oppScore > prevOpp) queueSound(sounds.base + sounds.onConcede);
    }
    _prevScores[key] = {hs, as};
  });

  // ── Rival losses (final) ──
  games.filter(g=>g.state==='post').forEach(g=>{
    if(_rivalSeen[g.id]) return;
    _rivalSeen[g.id] = true;

    // Generic win/lose for non-Corinthians fav teams
    for(const [, ts] of Object.entries(TEAM_SOUNDS)){
      if(ts.skipGeneric) continue;
      const search = ts.search || [];
      const fh = search.some(s=>g.home?.toLowerCase().includes(s));
      const fa = search.some(s=>g.away?.toLowerCase().includes(s));
      if(!fh && !fa) continue;
      const hs = parseInt(g.home_score)||0;
      const as_ = parseInt(g.away_score)||0;
      const won = (fh && hs > as_) || (fa && as_ > hs);
      const lost = (fh && hs < as_) || (fa && as_ < hs);
      if(won)  queueSound(pickRandom(GENERIC_WIN_SOUNDS));
      if(lost) queueSound(pickRandom(GENERIC_LOSE_SOUNDS));
      break;
    }

    // Rival celebrations
    for(const {search, sound} of RIVAL_SOUNDS){
      const rh = search.some(s=>g.home?.toLowerCase().includes(s));
      const ra = search.some(s=>g.away?.toLowerCase().includes(s));
      if(!rh && !ra) continue;
      const hs = parseInt(g.home_score)||0;
      const as_ = parseInt(g.away_score)||0;
      const lost = (rh && hs < as_) || (ra && as_ < hs);
      if(lost){ queueSound(sound); break; }
    }
  });
}

// ── Date helpers ──────────────────────────────────────────────────────────────
function toDateStr(d){ return d.toLocaleDateString('en-CA',{timeZone:'America/Los_Angeles'}).replace(/-/g,''); }
function fromDateStr(s){ return new Date(s.slice(0,4)+'-'+s.slice(4,6)+'-'+s.slice(6,8)+'T12:00:00'); }
function todayStr(){ return toDateStr(new Date()); }
function labelForDate(s){
  const today = todayStr();
  const tomorrow = toDateStr(new Date(Date.now()+86400000));
  const yesterday = toDateStr(new Date(Date.now()-86400000));
  if(s===today) return 'Today';
  if(s===tomorrow) return 'Tomorrow';
  if(s===yesterday) return 'Yesterday';
  const d = fromDateStr(s);
  return d.toLocaleDateString('en-US',{weekday:'short',month:'short',day:'numeric',timeZone:'America/Los_Angeles'});
}
function shiftDate(s, days){
  const d = fromDateStr(s);
  d.setDate(d.getDate()+days);
  return toDateStr(d);
}

function useFetch(url, interval=0) {
  const [data,setData]       = useState(null);
  const [loading,setLoading] = useState(true);
  const fetch_ = useCallback(async()=>{
    try{
      const r=await fetch(url);
      if(!r.ok) throw new Error(r.statusText);
      setData(await r.json());
    }catch(e){}finally{setLoading(false);}
  },[url]);
  useEffect(()=>{
    fetch_();
    if(interval){const id=setInterval(fetch_,interval);return()=>clearInterval(id);}
  },[fetch_,interval]);
  return {data,loading};
}

// ── Mask ──────────────────────────────────────────────────────────────────────
// Sports: black body, gold horns
function MaskSmall(){
  return(
    <svg width="36" height="36" viewBox="-60 30 320 260" aria-hidden="true">
      <ellipse cx="100" cy="130" rx="105" ry="100" fill="#0a0a0a" stroke="#0a0a0a" strokeWidth="3"/>
      <ellipse cx="100" cy="142" rx="80" ry="70" fill="#1a1a1a" stroke="#111" strokeWidth="2"/>
      <ellipse cx="62" cy="136" rx="30" ry="34" fill="#282828" stroke="#1e1e1e" strokeWidth="1.5"/>
      <ellipse cx="62" cy="136" rx="18" ry="22" fill="#333" stroke="#282828" strokeWidth="1"/>
      <circle cx="62" cy="136" r="8" fill="#050505"/><circle cx="67" cy="129" r="3.5" fill="#fff" opacity="0.85"/>
      <ellipse cx="138" cy="136" rx="30" ry="34" fill="#282828" stroke="#1e1e1e" strokeWidth="1.5"/>
      <ellipse cx="138" cy="136" rx="18" ry="22" fill="#333" stroke="#282828" strokeWidth="1"/>
      <circle cx="138" cy="136" r="8" fill="#050505"/><circle cx="143" cy="129" r="3.5" fill="#fff" opacity="0.85"/>
      <path d="M88,100 L100,78 L112,100" fill="none" stroke="#c9a030" strokeWidth="3.5"/>
      <path d="M44,106 Q62,88 80,106" fill="none" stroke="#e0b84a" strokeWidth="2.5"/>
      <path d="M120,106 Q138,88 156,106" fill="none" stroke="#e0b84a" strokeWidth="2.5"/>
      <polygon points="100,22 93,42 107,42" fill="#c9a030"/>
      <polygon points="64,28 57,48 71,48" fill="#c9a030"/>
      <polygon points="136,28 129,48 143,48" fill="#c9a030"/>
      <polygon points="-8,130 14,120 14,140" fill="#e0b84a"/>
      <polygon points="208,130 186,120 186,140" fill="#e0b84a"/>
      <polygon points="18,206 36,180 50,210" fill="#e0b84a"/>
      <polygon points="100,238 93,218 107,218" fill="#e0b84a"/>
      <polygon points="182,206 164,180 178,210" fill="#e0b84a"/>
    </svg>
  );
}

// ── Site nav masks ─────────────────────────────────────────────────────────────
// Cards: navy body, blue horns
function MaskCards(){
  return(
    <svg width="26" height="26" viewBox="-60 30 320 260" aria-hidden="true">
      <ellipse cx="100" cy="130" rx="105" ry="100" fill="#060c1e" stroke="#060c1e" strokeWidth="3"/>
      <ellipse cx="100" cy="142" rx="80" ry="70" fill="#0d1a3a" stroke="#0a1428" strokeWidth="2"/>
      <ellipse cx="62" cy="136" rx="30" ry="34" fill="#1a2e6a" stroke="#142258" strokeWidth="1.5"/>
      <ellipse cx="62" cy="136" rx="18" ry="22" fill="#2a4aaa" stroke="#1e3888" strokeWidth="1"/>
      <circle cx="62" cy="136" r="8" fill="#030610"/><circle cx="67" cy="129" r="3.5" fill="#fff" opacity="0.85"/>
      <ellipse cx="138" cy="136" rx="30" ry="34" fill="#1a2e6a" stroke="#142258" strokeWidth="1.5"/>
      <ellipse cx="138" cy="136" rx="18" ry="22" fill="#2a4aaa" stroke="#1e3888" strokeWidth="1"/>
      <circle cx="138" cy="136" r="8" fill="#030610"/><circle cx="143" cy="129" r="3.5" fill="#fff" opacity="0.85"/>
      <path d="M88,100 L100,78 L112,100" fill="none" stroke="#5a8aff" strokeWidth="3.5"/>
      <path d="M44,106 Q62,88 80,106" fill="none" stroke="#7aaaff" strokeWidth="2.5"/>
      <path d="M120,106 Q138,88 156,106" fill="none" stroke="#7aaaff" strokeWidth="2.5"/>
      <polygon points="100,22 93,42 107,42" fill="#5a8aff"/>
      <polygon points="64,28 57,48 71,48" fill="#5a8aff"/>
      <polygon points="136,28 129,48 143,48" fill="#5a8aff"/>
      <polygon points="-8,130 14,120 14,140" fill="#7aaaff"/>
      <polygon points="208,130 186,120 186,140" fill="#7aaaff"/>
      <polygon points="18,206 36,180 50,210" fill="#7aaaff"/>
      <polygon points="100,238 93,218 107,218" fill="#7aaaff"/>
      <polygon points="182,206 164,180 178,210" fill="#7aaaff"/>
    </svg>
  );
}
// Codex: wine body, gold horns
function MaskCodex(){
  return(
    <svg width="26" height="26" viewBox="-60 30 320 260" aria-hidden="true">
      <ellipse cx="100" cy="130" rx="105" ry="100" fill="#200608" stroke="#200608" strokeWidth="3"/>
      <ellipse cx="100" cy="142" rx="80" ry="70" fill="#500818" stroke="#380410" strokeWidth="2"/>
      <ellipse cx="62" cy="136" rx="30" ry="34" fill="#7a1020" stroke="#580c18" strokeWidth="1.5"/>
      <ellipse cx="62" cy="136" rx="18" ry="22" fill="#9b1a2c" stroke="#7a1020" strokeWidth="1"/>
      <circle cx="62" cy="136" r="8" fill="#060102"/><circle cx="67" cy="129" r="3.5" fill="#fff" opacity="0.8"/>
      <ellipse cx="138" cy="136" rx="30" ry="34" fill="#7a1020" stroke="#580c18" strokeWidth="1.5"/>
      <ellipse cx="138" cy="136" rx="18" ry="22" fill="#9b1a2c" stroke="#7a1020" strokeWidth="1"/>
      <circle cx="138" cy="136" r="8" fill="#060102"/><circle cx="143" cy="129" r="3.5" fill="#fff" opacity="0.8"/>
      <path d="M88,100 L100,78 L112,100" fill="none" stroke="#c9a030" strokeWidth="3.5"/>
      <path d="M44,106 Q62,88 80,106" fill="none" stroke="#e0b84a" strokeWidth="2.5"/>
      <path d="M120,106 Q138,88 156,106" fill="none" stroke="#e0b84a" strokeWidth="2.5"/>
      <polygon points="100,22 93,42 107,42" fill="#c9a030"/>
      <polygon points="64,28 57,48 71,48" fill="#c9a030"/>
      <polygon points="136,28 129,48 143,48" fill="#c9a030"/>
      <polygon points="-8,130 14,120 14,140" fill="#e0b84a"/>
      <polygon points="208,130 186,120 186,140" fill="#e0b84a"/>
      <polygon points="18,206 36,180 50,210" fill="#e0b84a"/>
      <polygon points="100,238 93,218 107,218" fill="#e0b84a"/>
      <polygon points="182,206 164,180 178,210" fill="#e0b84a"/>
    </svg>
  );
}

function MaskMythos(){
  return(
    <svg width="26" height="26" viewBox="-60 30 320 260" aria-hidden="true">
      <ellipse cx="100" cy="130" rx="105" ry="100" fill="#f1ece0" stroke="#2b2723" strokeWidth="3"/>
      <ellipse cx="100" cy="142" rx="80" ry="70" fill="#f8f4ec" stroke="#cdc4b2" strokeWidth="2"/>
      <ellipse cx="62" cy="136" rx="30" ry="34" fill="#ffffff" stroke="#2b2723" strokeWidth="2"/>
      <ellipse cx="62" cy="136" rx="18" ry="22" fill="#ddd6c8" stroke="#2b2723" strokeWidth="1"/>
      <circle cx="62" cy="136" r="8" fill="#1f1b16"/><circle cx="67" cy="129" r="3.5" fill="#fff" opacity="0.9"/>
      <ellipse cx="138" cy="136" rx="30" ry="34" fill="#ffffff" stroke="#2b2723" strokeWidth="2"/>
      <ellipse cx="138" cy="136" rx="18" ry="22" fill="#ddd6c8" stroke="#2b2723" strokeWidth="1"/>
      <circle cx="138" cy="136" r="8" fill="#1f1b16"/><circle cx="143" cy="129" r="3.5" fill="#fff" opacity="0.9"/>
      <path d="M88,100 L100,78 L112,100" fill="none" stroke="#2b2723" strokeWidth="3.5"/>
      <path d="M44,106 Q62,88 80,106" fill="none" stroke="#6e665c" strokeWidth="2.5"/>
      <path d="M120,106 Q138,88 156,106" fill="none" stroke="#6e665c" strokeWidth="2.5"/>
      <polygon points="100,22 93,42 107,42" fill="#f1ece0" stroke="#2b2723" strokeWidth="1.5"/>
      <polygon points="64,28 57,48 71,48" fill="#f1ece0" stroke="#2b2723" strokeWidth="1.5"/>
      <polygon points="136,28 129,48 143,48" fill="#f1ece0" stroke="#2b2723" strokeWidth="1.5"/>
      <polygon points="-8,130 14,120 14,140" fill="#f1ece0" stroke="#2b2723" strokeWidth="1.5"/>
      <polygon points="208,130 186,120 186,140" fill="#f1ece0" stroke="#2b2723" strokeWidth="1.5"/>
      <polygon points="18,206 36,180 50,210" fill="#f1ece0" stroke="#2b2723" strokeWidth="1.5"/>
      <polygon points="100,238 93,218 107,218" fill="#f1ece0" stroke="#2b2723" strokeWidth="1.5"/>
      <polygon points="182,206 164,180 178,210" fill="#f1ece0" stroke="#2b2723" strokeWidth="1.5"/>
    </svg>
  );
}

// ── Site nav links ────────────────────────────────────────────────────────────
function MaskJobs(){
  return(
    <svg width="26" height="26" viewBox="-60 30 320 260" aria-hidden="true">
      <ellipse cx="100" cy="130" rx="105" ry="100" fill="#161B20" stroke="#161B20" strokeWidth="3"/>
      <ellipse cx="100" cy="142" rx="80" ry="70" fill="#2b333b" stroke="#20262c" strokeWidth="2"/>
      <ellipse cx="62" cy="136" rx="30" ry="34" fill="#3C464F" stroke="#2f373f" strokeWidth="1.5"/>
      <ellipse cx="62" cy="136" rx="18" ry="22" fill="#5a6670" stroke="#3C464F" strokeWidth="1"/>
      <circle cx="62" cy="136" r="8" fill="#0a0d10"/><circle cx="67" cy="129" r="3.5" fill="#fff" opacity="0.85"/>
      <ellipse cx="138" cy="136" rx="30" ry="34" fill="#3C464F" stroke="#2f373f" strokeWidth="1.5"/>
      <ellipse cx="138" cy="136" rx="18" ry="22" fill="#5a6670" stroke="#3C464F" strokeWidth="1"/>
      <circle cx="138" cy="136" r="8" fill="#0a0d10"/><circle cx="143" cy="129" r="3.5" fill="#fff" opacity="0.85"/>
      <path d="M88,100 L100,78 L112,100" fill="none" stroke="#F0B429" strokeWidth="3.5"/>
      <path d="M44,106 Q62,88 80,106" fill="none" stroke="#F0B429" strokeWidth="2.5"/>
      <path d="M120,106 Q138,88 156,106" fill="none" stroke="#F0B429" strokeWidth="2.5"/>
      <polygon points="100,22 93,42 107,42" fill="#F0B429"/>
      <polygon points="64,28 57,48 71,48" fill="#c99a1f"/>
      <polygon points="136,28 129,48 143,48" fill="#c99a1f"/>
      <polygon points="-8,130 14,120 14,140" fill="#c99a1f"/>
      <polygon points="208,130 186,120 186,140" fill="#c99a1f"/>
      <polygon points="18,206 36,180 50,210" fill="#c99a1f"/>
      <polygon points="100,238 93,218 107,218" fill="#c99a1f"/>
      <polygon points="182,206 164,180 178,210" fill="#c99a1f"/>
    </svg>
  );
}

const SITE_LINKS = [
  { href:'https://sports.majorasmask.us', Mask: MaskSmall, label:'Sports'  },
  { href:'https://cards.majorasmask.us',  Mask: MaskCards,  label:'Cards'   },
  { href:'https://codex.majorasmask.us',  Mask: MaskCodex,  label:'Codex'   },
  { href:'https://jobs.majorasmask.us',   Mask: MaskJobs,   label:'Jobs'   },
];

// ── Baseball bases ────────────────────────────────────────────────────────────
function Bases({onFirst,onSecond,onThird}){
  const on='#d4a427',off='#2a2200';
  return(
    <svg width="44" height="40" viewBox="0 0 44 40">
      <rect x="18" y="2"  width="8" height="8" fill={onSecond?on:off} transform="rotate(45 22 6)"/>
      <rect x="4"  y="16" width="8" height="8" fill={onThird?on:off}  transform="rotate(45 8 20)"/>
      <rect x="32" y="16" width="8" height="8" fill={onFirst?on:off}  transform="rotate(45 36 20)"/>
      <rect x="18" y="30" width="8" height="8" fill="#555"            transform="rotate(45 22 34)"/>
    </svg>
  );
}

// ── Game detail modal ─────────────────────────────────────────────────────────
function GameDetailModal({game,onClose}){
  const leagueKey = game._league_key || leagueToKey(game.league);
  const sport     = leagueToFilter(game.league);
  const isF1      = game._league_key==='f1';
  const [detail,setDetail] = useState(null);
  const [f1Data,setF1Data] = useState(null);
  const [loading,setLoading] = useState(true);
  useEffect(()=>{
    if(game._league_key==='ufc'){ setLoading(false); return; }
    if(isF1){
      const sessionName = game.home||'';
      fetch(`${API}/f1/session?session_name=${encodeURIComponent(sessionName)}`)
        .then(r=>r.json()).then(d=>{setF1Data(d);setLoading(false);})
        .catch(()=>setLoading(false));
      return;
    }
    if(!game.id||!leagueKey){setLoading(false);return;}
    fetch(`${API}/game/${leagueKey}/${game.id}`)
      .then(r=>r.json()).then(d=>{setDetail(d);setLoading(false);})
      .catch(()=>setLoading(false));
  },[game.id,leagueKey,isF1]);

  return(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e=>e.stopPropagation()}>
        <div className="modal-header">
          <div style={{flex:1}}>
            {isF1 ? (
              <div className="modal-f1-header">
                <img src={LEAGUE_LOGOS.f1} className="modal-f1-logo" alt="F1"/>
                <div>
                  <div className="modal-f1-event">{f1Name(game.away)}</div>
                  <div className="modal-f1-session">{game.home} · {game.state==='post'?'Final':game.state==='in'?(game.detail||'Live'):game.start_time}</div>
                </div>
              </div>
            ) : (<>
            <div className="modal-league">{game.league}{game.is_playoff&&<span className="playoff-tag">Playoffs</span>}</div>
            <div className="modal-matchup">
              <div className="modal-team">
                {game.home_logo&&<img src={game.home_logo} alt="" className="modal-logo"/>}
                <span className={game.home_fav?'modal-fav':''}>{game.home}</span>
              </div>
              <div className="modal-score-block">
                {(game.home_score||game.away_score)
                  ?<><span className="modal-score">{game.home_score}</span><span className="modal-score-sep">–</span><span className="modal-score">{game.away_score}</span></>
                  :<span className="modal-vs">vs</span>}
              </div>
              <div className="modal-team modal-team-away">
                {game.away_logo&&<img src={game.away_logo} alt="" className="modal-logo"/>}
                <span className={game.away_fav?'modal-fav':''}>{game.away}</span>
              </div>
            </div>
            {game.series_summary&&<div className="modal-series">{game.series_summary}</div>}
            <div className="modal-detail">
              {game.state==='in'?game.detail:(game.state==='post'&&game.detail?.toLowerCase().includes('postponed'))?'Postponed':game.state==='post'?'Final':game.start_time}
              {game.broadcast&&<span className="modal-broadcast">{game.broadcast}</span>}
            </div>
            {game.notes&&<div className="modal-notes">{game.notes}</div>}
            </>)}
          </div>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {game._league_key==='ufc'&&game.fights&&game.fights.length>0&&(
            <div className="detail-section">
              <div className="detail-section-title">Fight Card</div>
              <div className="ufc-live-list">
                {game.fights.map((f,i)=>{
                  const decided = f.winner1||f.winner2;
                  const Corner = ({name,head,rec,win})=>(
                    <div className={`ufcl-corner ${decided?(win?'ufcl-win':'ufcl-lose'):''}`}>
                      <div className="ufcl-photo-wrap">
                        {head?<img src={head} alt="" className="ufcl-photo" onError={e=>e.target.style.display='none'}/>:<div className="ufcl-photo ufcl-photo-ph">🥊</div>}
                        {win&&<span className="ufcl-belt">WIN</span>}
                      </div>
                      <div className={`ufcl-name ${decided&&!win?'ufcl-struck':''}`}>{name}</div>
                      {rec&&<div className="ufcl-rec">{rec}</div>}
                    </div>
                  );
                  return(
                    <div key={i} className={`ufcl-fight ${i===0?'ufcl-main':''}`}>
                      <div className="ufcl-weight">{i===0?'★ MAIN EVENT':''}{f.weight?`${i===0?' · ':''}${f.weight}`:''}</div>
                      <div className="ufcl-bout">
                        <Corner name={f.fighter1} head={f.headshot1} rec={f.record1} win={f.winner1}/>
                        <div className="ufcl-vs">VS</div>
                        <Corner name={f.fighter2} head={f.headshot2} rec={f.record2} win={f.winner2}/>
                      </div>
                      {f.status&&<div className="ufcl-status">{f.status}</div>}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {loading&&game._league_key!=='ufc'&&<div className="loading"><div className="spinner"/></div>}
          {!loading&&isF1&&f1Data&&(
            <div className="detail-section">
              <div className="detail-section-title">{f1Data.session_name} · {f1Data.circuit}</div>
              <div className="f1-results">
                {f1Data.results?.map((r,i)=>(
                  <div key={i} className="f1-result-row">
                    <span className="f1-pos">{r.position}</span>
                    <span className="f1-driver">{r.driver}</span>
                    <span className="f1-team" style={{color:r.color||'#888'}}>{r.team}</span>
                    <span className="f1-time">{r.gap||r.best_lap||''}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
          {!loading&&detail&&<>
            {detail.fightCard?.length>0&&(
              <div className="detail-section">
                <div className="detail-section-title">Fight Card</div>
                <div className="fight-card-list">
                  {detail.fightCard.map((f,i)=>(
                    <div key={i} className={`fight-row ${f.isMain?'fight-main':''}`}>
                      <div className="fight-fighters">
                        <span className={f.winner===true?'fight-winner':'fight-fighter'}>{f.fighter1}</span>
                        <span className="fight-vs">vs</span>
                        <span className={f.winner===false?'fight-winner':'fight-fighter'}>{f.fighter2}</span>
                      </div>
                      {(f.result||f.method)&&(
                        <div className="fight-result">
                          {f.method&&<span className="fight-method">{f.method}</span>}
                          {f.round&&<span className="fight-detail">R{f.round}</span>}
                          {f.time&&<span className="fight-detail">{f.time}</span>}
                          {!f.method&&f.result&&<span className="fight-method">{f.result}</span>}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {detail.situation?.outs!=null&&(
              <div className="detail-section">
                <div className="detail-section-title">Live Situation</div>
                <div className="mlb-situation">
                  <div className="mlb-sit-diamond">
                    <Bases onFirst={detail.situation.onFirst} onSecond={detail.situation.onSecond} onThird={detail.situation.onThird}/>
                    <div className="mlb-count">
                      <span className="mlb-count-item">{detail.situation.outs} <em>out</em></span>
                      <span className="mlb-count-item">{detail.situation.balls}-{detail.situation.strikes} <em>count</em></span>
                    </div>
                  </div>
                  <div className="mlb-matchup">
                    {detail.situation.pitcher&&(
                      <div className="mlb-mp">
                        <span className="mlb-mp-role">⚾ Pitching</span>
                        <span className="mlb-mp-name">{detail.situation.pitcher}</span>
                        <span className="mlb-mp-stats">{detail.situation.pitcherERA&&`ERA ${detail.situation.pitcherERA}`}{detail.situation.pitchCount?` · ${detail.situation.pitchCount} P`:''}</span>
                      </div>
                    )}
                    {detail.situation.batter&&(
                      <div className="mlb-mp">
                        <span className="mlb-mp-role">🏏 At Bat</span>
                        <span className="mlb-mp-name">{detail.situation.batter}</span>
                        <span className="mlb-mp-stats">{detail.situation.batterAvg&&`AVG ${detail.situation.batterAvg}`}{detail.situation.batterHR?` · ${detail.situation.batterHR} HR`:''}{detail.situation.batterRBI?` · ${detail.situation.batterRBI} RBI`:''}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
            {detail.situation?.down>0&&(
              <div className="detail-chip-row">
                <span className="detail-chip">{detail.situation.detail}</span>
                {detail.situation.yardLine&&<span className="detail-chip">Yard {detail.situation.yardLine}</span>}
              </div>
            )}



            {/* MLB line score */}
            {detail.lineScore&&detail.lineScore.length>0&&(
              <div className="detail-section">
                <div className="detail-section-title">Line Score</div>
                <div className="line-score">
                  <div className="line-score-header">
                    <span className="line-team-col"></span>
                    {detail.lineScore[0]?.runs?.map((_,i)=>(
                      <span key={i} className="line-inn">{i+1}</span>
                    ))}
                    <span className="line-inn line-total">R</span>
                  </div>
                  {detail.lineScore.map((row,i)=>(
                    <div key={i} className="line-score-row">
                      <span className="line-team-col">{row.team}</span>
                      {row.runs.map((r,j)=>(
                        <span key={j} className="line-inn">{r}</span>
                      ))}
                      <span className="line-inn line-total">{row.total}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* MLB pitchers */}
            {detail.pitchers&&detail.pitchers.length>0&&(
              <div className="detail-section">
                <div className="detail-section-title">Pitchers</div>
                <div className="pitchers-grid">
                  {detail.pitchers.map((p,i)=>(
                    <div key={i} className="pitcher-row">
                      <span className="pitcher-team">{p.team}</span>
                      <span className="pitcher-name">{p.name}</span>
                      <div className="pitcher-stats">
                        {p.ip&&<span>{p.ip} IP</span>}
                        {p.er&&<span>{p.er} ER</span>}
                        {p.k&&<span>{p.k} K</span>}
                        {p.era&&<span>ERA {p.era}</span>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {detail.leaders?.length>0&&detail.leaders.some(l=>l.name)&&(
              <div className="detail-section">
                <div className="detail-section-title">Leaders</div>
                <div className="leaders-grid">
                  {detail.leaders.filter(l=>l.name).map((l,i)=>(
                    <div key={i} className="leader-item">
                      <div className="leader-cat">{l.category}</div>
                      <div className="leader-name">{l.name}<span className="leader-team"> {l.team}</span></div>
                      <div className="leader-val">{l.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {detail.soccerEvents?.length>0&&(
              <div className="detail-section">
                <div className="sx-header">
                  <span className="sx-team-name">{game.home}</span>
                  <span className="sx-vs">match events</span>
                  <span className="sx-team-name sx-team-away">{game.away}</span>
                </div>
                <div className="sx-timeline">
                  {detail.soccerEvents.map((e,i)=>{
                    const icon = e.kind==='goal'?'⚽':e.kind==='penalty'?'⚽':e.kind==='own'?'⚽':e.kind==='yellow'?'🟨':e.kind==='red'?'🟥':'🔄';
                    const isGoal = e.kind==='goal'||e.kind==='penalty'||e.kind==='own';
                    const cell = (
                      <div className={`sx-ev ${isGoal?'sx-goal':''}`}>
                        <span className="sx-ev-icon">{icon}</span>
                        <span className="sx-ev-text">
                          <span className="sx-ev-player">{e.player}</span>
                          {e.detail&&<span className="sx-ev-detail">{e.detail}</span>}
                        </span>
                      </div>
                    );
                    return (
                      <div key={i} className="sx-row">
                        <div className="sx-side sx-left">{e.side==='home'?cell:null}</div>
                        <div className="sx-min">{e.clock||''}</div>
                        <div className="sx-side sx-right">{e.side==='away'?cell:(e.side===''?cell:null)}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {detail.scoringPlays?.length>0&&detail.sport!=='soccer'&&!detail.scoringPlays.some(p=>p.kind)&&(
              <div className="detail-section">
                <div className="detail-section-title">Scoring Plays</div>
                <div className="scoring-plays">
                  {detail.scoringPlays.map((p,i)=>(
                    <div key={i} className="scoring-play">
                      <div className="play-meta">
                        <span className="play-team">{p.team}</span>
                        <span className="play-clock">{p.period} {p.clock}</span>
                        {(p.homeScore||p.awayScore)&&<span className="play-score">{p.awayScore}–{p.homeScore}</span>}
                      </div>
                      <div className="play-text">{p.text}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {detail.stats?.length>0&&(
              <div className="detail-section">
                <div className="detail-section-title">Team Stats</div>
                <div className="stats-grid">
                  {detail.stats.map((ts,i)=>(
                    <div key={i} className="team-stat-col">
                      <div className="team-stat-header">{ts.team}</div>
                      {ts.stats.map((s,j)=>(
                        <div key={j} className="stat-row">
                          <span className="stat-label">{s.label}</span>
                          <span className="stat-val">{s.value}</span>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {detail.error&&<div className="empty">Stats not available.</div>}
          </>}
        </div>
      </div>
    </div>
  );
}

// ── Game Card ─────────────────────────────────────────────────────────────────
function TeamAvatar({src,name,cls='live-poster-logo'}){
  const [bad,setBad] = useState(false);
  if(src && !bad) return <img src={src} alt="" className={cls} onError={()=>setBad(true)}/>;
  const initials = (name||'').replace(/^#\d+\s*/,'').split(/\s+/).filter(Boolean).slice(0,2).map(w=>w[0]).join('').toUpperCase();
  return <div className={`${cls} avatar-ph`}>{initials||'?'}</div>;
}

function GameCard({game,compact=false}){
  const [showModal,setShowModal] = useState(false);
  const isLive = game.state==='in';
  const isDone = game.state==='post'||game.state==='postponed';

  // F1 sessions store the session name in `home` and event name in `away`;
  // render them as a single session row instead of a two-team matchup.
  if(game._league_key==='f1'){
    const f1CanExpand = isLive||isDone;
    return(
      <>
        <div className={`game-card f1-session-card ${isLive?'live-card':''} ${compact?'compact-card':''}`}
          onClick={f1CanExpand?()=>setShowModal(true):undefined}
          style={f1CanExpand?{cursor:'pointer'}:{}}>
          <div className="game-card-top">
            <span className="game-league f1-tag">F1</span>
            <div style={{display:'flex',gap:'5px',alignItems:'center'}}>
              {isLive&&<span className="live-dot"/>}
              {f1CanExpand&&<span className="expand-hint">results</span>}
            </div>
          </div>
          <div className="f1-gp-name">{f1Name(game.away)}</div>
          <div className="f1-session-body">
            <span className="f1-session-title">{game.home}</span>
            <span className="f1-session-status">
              {isLive?(game.detail||'Live'):isDone?'Final':(game.start_time||'TBD')}
            </span>
          </div>
          {game.broadcast&&!isDone&&<div className="game-meta"><span className="broadcast-chip">{game.broadcast}</span></div>}
        </div>
        {showModal&&<GameDetailModal game={game} onClose={()=>setShowModal(false)}/>}
      </>
    );
  }

  const favGame = game.home_fav||game.away_fav;
  const homeWin = (isLive||isDone)&&parseInt(game.home_score)>parseInt(game.away_score);
  const awayWin = (isLive||isDone)&&parseInt(game.away_score)>parseInt(game.home_score);
  const leagueKey = game._league_key || leagueToKey(game.league);
  const isUFC = game._league_key==='ufc';
  const canExpand = isUFC || ((isLive||isDone)&&leagueKey);

  return(
    <>
      <div className={`game-card ${isLive?'live-card':''} ${favGame?'fav-card':''} ${game.is_playoff?'playoff-card':''} ${compact?'compact-card':''}`}
        onClick={canExpand?()=>setShowModal(true):undefined}
        style={canExpand?{cursor:'pointer'}:{}}>
        <div className="game-card-top">
          <span className="game-league">{game.league}{game.is_playoff&&<span className="po-badge">PO</span>}</span>
          <div style={{display:'flex',gap:'5px',alignItems:'center'}}>
            {isLive&&<span className="live-dot"/>}
            {canExpand&&<span className="expand-hint">stats</span>}
          </div>
        </div>
        {game.series_summary&&<div className="series-summary">{game.series_summary}</div>}
        {!game.series_summary&&game.notes&&<div className="game-notes">{game.notes}</div>}

        {/* ── poster layout for all states ── */}
        <div className="live-poster">
          <div className="live-poster-team">
            <TeamAvatar src={game.home_logo} name={game.home}/>
            <span className={`live-poster-name ${game.home_fav?'fav-team-name':''}`}>{game.home}</span>
          </div>
          <div className="live-poster-center">
            {(isLive||isDone)&&game.home_score!==''
              ? <div className="live-poster-score">
                  <span className={homeWin?'winning':''}>{game.home_score}</span>
                  <span className="live-poster-sep">–</span>
                  <span className={awayWin?'winning':''}>{game.away_score}</span>
                </div>
              : <div className="live-poster-time">{game.start_time||'TBD'}</div>
            }
            {isLive&&<div className="live-poster-clock">{game.detail}</div>}
            {isDone&&<div className="live-poster-final">
              {game.detail?.toLowerCase().includes('postponed')?'Postponed':'Final'}
            </div>}
            {!isLive&&!isDone&&game.broadcast&&<div className="live-poster-broadcast">{game.broadcast}</div>}
          </div>
          <div className="live-poster-team live-poster-team-away">
            <TeamAvatar src={game.away_logo} name={game.away}/>
            <span className={`live-poster-name ${game.away_fav?'fav-team-name':''}`}>{game.away}</span>
          </div>
        </div>
        {isLive&&game.broadcast&&<div className="game-meta"><span className="broadcast-chip">{game.broadcast}</span></div>}
        {isDone&&game.broadcast&&<div className="game-meta"><span className="broadcast-chip">{game.broadcast}</span></div>}
      </div>
      {showModal&&<GameDetailModal game={game} onClose={()=>setShowModal(false)}/>}
    </>
  );
}

// ── Upcoming Row ──────────────────────────────────────────────────────────────
function UpcomingRow({game}){
  const favGame = game.home_fav||game.away_fav;
  const leagueKey = game._league_key || leagueToKey(game.league);
  const leagueLogo = LEAGUE_LOGOS[leagueKey];
  const icon = SPORT_ICONS[leagueToFilter(game.league)]||'⚽';
  const isF1 = game._league_key==='f1';
  return(
    <div className={`upcoming-row ${favGame?'fav-upcoming':''} ${game.is_playoff?'playoff-row':''}`}>
      <div className="upcoming-icon">
        {leagueLogo
          ?<img src={leagueLogo} alt="" className="league-logo" onError={e=>e.target.style.display='none'}/>
          :<span>{icon}</span>}
      </div>
      <div className="upcoming-teams">
        {isF1
          ?<div className="upcoming-matchup"><span className="f1-session-name">{game.home}</span></div>
          :<div className="upcoming-poster">
            <div className="upcoming-poster-team">
              {game.home_logo&&<img src={game.home_logo} alt="" className="upcoming-poster-logo"/>}
              <span className={`upcoming-poster-name ${game.home_fav?'fav-name':''}`}>{game.home}</span>
            </div>
            <span className="upcoming-poster-vs">vs</span>
            <div className="upcoming-poster-team">
              {game.away_logo&&<img src={game.away_logo} alt="" className="upcoming-poster-logo"/>}
              <span className={`upcoming-poster-name ${game.away_fav?'fav-name':''}`}>{game.away}</span>
            </div>
            {game.is_playoff&&<span className="po-badge-inline">PO</span>}
          </div>}
        {game.series_summary&&<div className="upcoming-series">{game.series_summary}</div>}
        {!game.series_summary&&game.notes&&<div className="upcoming-notes">{game.notes}</div>}
        <div className="upcoming-league">{game.league}</div>
      </div>
      <div className="upcoming-right">
        <div className="upcoming-time">{game.start_time||'—'}</div>
        {game.broadcast
          ?<div className="upcoming-channel">{game.broadcast}</div>
          :<div className="upcoming-channel no-broadcast">TBD</div>}
      </div>
    </div>
  );
}

function groupBySport(games){
  const groups={};
  games.forEach(g=>{
    const k=leagueToFilter(g.league);
    if(!groups[k])groups[k]=[];
    groups[k].push(g);
  });
  const sorted={};
  SPORT_ORDER.forEach(k=>{if(groups[k])sorted[k]=groups[k];});
  return sorted;
}

function SportSection({sportKey,games,cardView=false}){
  return(
    <div className="sport-section">
      <div className="sport-section-label">{sportKey==='f1' ? <><img src={LEAGUE_LOGOS.f1} className="f1-logo-inline" alt=""/>F1</> : (SPORT_LABELS[sportKey]||sportKey)}</div>
      {cardView
        ?<div className="game-grid">{games.map(g=><GameCard key={g.id} game={g}/>)}</div>
        :<div className="upcoming-list">{games.map(g=><UpcomingRow key={g.id} game={g}/>)}</div>}
    </div>
  );
}

// ── Daily Spotlight ───────────────────────────────────────────────────────────
function DailySpotlight(){
  const {data:picks,loading} = useFetch(`${API}/spotlight`,60000);
  const [modalGame,setModalGame] = useState(null);
  if(loading||!picks||picks.length===0) return null;
  const canExpand = (pick) => pick.state==='in'||pick.state==='post';
  return(
    <section>
      <div className="section-header">
        <h2 className="section-title">🔦 Daily Spotlight</h2>
        <span className="tz-note">updated hourly</span>
      </div>
      {modalGame&&<GameDetailModal game={modalGame} onClose={()=>setModalGame(null)}/>}
      <div className="spotlight-grid">
        {picks.map((pick,i)=>(
          <div key={i} className={`spotlight-card ${pick.is_playoff?'spotlight-playoff':''} ${canExpand(pick)?'spotlight-clickable':''}`}
            onClick={canExpand(pick)?()=>setModalGame(pick):undefined}>
            {/* blurred bg logos */}
            {pick.home_logo&&<img src={pick.home_logo} alt="" className="spotlight-bg-logo spotlight-bg-home"/>}
            {pick.away_logo&&<img src={pick.away_logo} alt="" className="spotlight-bg-logo spotlight-bg-away"/>}
            <div className="spotlight-card-inner">
              {pick.is_playoff&&<div className="spotlight-playoff-banner">🏆 Playoffs</div>}
              <div className="spotlight-top-row">
                <span className="spotlight-num">#{i+1}</span>
                <span className="spotlight-league">{pick.league}</span>
              </div>
              {/* match poster */}
              <div className="spotlight-poster">
                <div className="spotlight-poster-team">
                  <TeamAvatar src={pick.home_logo} name={pick.home} cls="spotlight-poster-logo"/>
                  <span className={`spotlight-poster-name ${pick.home_fav?'fav-name':''}`}>{pick.home}</span>
                </div>
                <div className="spotlight-poster-center">
                  {pick.state==='in'
                    ?<span className="spotlight-live-score">{pick.home_score}<span className="spotlight-score-sep">–</span>{pick.away_score}</span>
                    :<span className="spotlight-vs">VS</span>}
                  {pick.state==='in'&&<span className="spotlight-live-badge">● LIVE</span>}
                </div>
                <div className="spotlight-poster-team spotlight-poster-team-away">
                  <TeamAvatar src={pick.away_logo} name={pick.away} cls="spotlight-poster-logo"/>
                  <span className={`spotlight-poster-name ${pick.away_fav?'fav-name':''}`}>{pick.away}</span>
                </div>
              </div>
              {pick.series_summary&&<div className="spotlight-series">{pick.series_summary}</div>}
              <div className="spotlight-reason">{pick.reason}</div>
              <div className="spotlight-meta">
                {pick.state==='in'
                  ?<span>{pick.detail}</span>
                  :<span>{pick.start_time}</span>}
                {pick.broadcast&&<span className="spotlight-broadcast">{pick.broadcast}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

// ── Tab: Live Now ─────────────────────────────────────────────────────────────
function cfbUntil(iso){
  if(!iso) return '';
  const ms = new Date(iso) - Date.now();
  if(isNaN(ms)||ms<=0) return '';
  const mins=Math.floor(ms/60000), hrs=Math.floor(mins/60), days=Math.floor(hrs/24);
  if(days>=1) return `in ${days} day${days===1?'':'s'}`;
  if(hrs>=1)  return `in ${hrs}h ${mins%60}m`;
  return `in ${mins}m`;
}

/* Game of the week: best ranked matchup, else a marquee-network game. */
function pickMarquee(games){
  if(!games||!games.length) return null;
  const live = games.filter(g=>g.state==='in');
  if(live.length) return live[0];
  const score = g=>{
    const hr=g.home_rank, ar=g.away_rank;
    if(hr&&ar) return hr+ar;
    if(hr||ar) return 100+(hr||ar);
    const bc=(g.broadcast||'').toUpperCase();
    return 500 + (['ABC','FOX','CBS','NBC','ESPN'].some(n=>bc.includes(n))?0:50);
  };
  return games.slice().sort((a,b)=>{
    const d=score(a)-score(b); if(d) return d;
    return (a.start_iso||'').localeCompare(b.start_iso||'');
  })[0];
}

function CFBMarquee({game}){
  if(!game) return null;
  const isLive=game.state==='in', isDone=game.state==='post';
  const until=cfbUntil(game.start_iso);
  return(
    <div className={`cfb-marquee ${isLive?'cfb-marquee-live':''}`}>
      <div className="cfb-marquee-top">
        <span className="cfb-motw">{isLive?'LIVE NOW':isDone?'HEADLINE GAME':'GAME OF THE WEEK'}</span>
        <span className="cfb-marquee-meta">
          {game.day_label}{game.start_time?` · ${game.start_time}`:''}{game.broadcast?` · ${game.broadcast}`:''}
        </span>
      </div>
      <div className="cfb-marquee-body">
        <div className="cfb-marquee-team">
          <TeamAvatar src={game.away_logo} name={game.away} cls="cfb-marquee-logo"/>
          <div className="cfb-marquee-name">{game.away}</div>
          {game.away_record&&<div className="cfb-marquee-rec">{game.away_record}</div>}
        </div>
        <div className="cfb-marquee-center">
          {isLive||isDone
            ? <div className="cfb-marquee-score">{game.away_score}<span className="cfb-marquee-sep">–</span>{game.home_score}</div>
            : <div className="cfb-marquee-vs">VS</div>}
          {isLive
            ? <div className="cfb-marquee-clock">{game.detail||'Live'}</div>
            : isDone
              ? <div className="cfb-marquee-count">Final</div>
              : until&&<div className="cfb-marquee-count">{until}</div>}
        </div>
        <div className="cfb-marquee-team">
          <TeamAvatar src={game.home_logo} name={game.home} cls="cfb-marquee-logo"/>
          <div className="cfb-marquee-name">{game.home}</div>
          {game.home_record&&<div className="cfb-marquee-rec">{game.home_record}</div>}
        </div>
      </div>
      <div className="cfb-marquee-foot">{game.away} at {game.home}</div>
    </div>
  );
}

function CFBRankings(){
  const [polls,setPolls] = useState(null);
  const [idx,setIdx]     = useState(0);
  useEffect(()=>{
    let alive=true;
    fetch('/api/cfb/rankings').then(r=>r.json())
      .then(d=>{ if(alive) setPolls((d&&d.polls)||[]); })
      .catch(()=>{ if(alive) setPolls([]); });
    return ()=>{ alive=false; };
  },[]);
  if(!polls) return <aside className="cfb-rank-panel"><div className="cfb-rank-title">Rankings</div><div className="cfb-rank-empty">Loading…</div></aside>;
  if(!polls.length) return <aside className="cfb-rank-panel"><div className="cfb-rank-title">Rankings</div><div className="cfb-rank-empty">Polls post once the season starts.</div></aside>;
  const poll = polls[Math.min(idx,polls.length-1)];
  return(
    <aside className="cfb-rank-panel">
      <div className="cfb-rank-title">{poll.short||poll.name}</div>
      {poll.headline&&<div className="cfb-rank-sub">{poll.headline}</div>}
      {polls.length>1&&
        <div className="cfb-rank-tabs">
          {polls.map((p,i)=>(
            <button key={p.id??i} className={`cfb-rank-tab ${i===idx?'active':''}`} onClick={()=>setIdx(i)}>
              {(p.short||p.name).replace(/\s*(Poll|Rankings|Top 25)\s*/i,'').trim()||p.short}
            </button>
          ))}
        </div>}
      <ol className="cfb-rank-list">
        {poll.entries.map(e=>(
          <li key={e.rank} className="cfb-rank-row">
            <span className={`cfb-rank-num ${e.rank<=4?'top4':''}`}>{e.rank}</span>
            <TeamAvatar src={e.logo} name={e.name} cls="cfb-rank-logo"/>
            <span className="cfb-rank-name">{e.name}</span>
            <span className="cfb-rank-rec">{e.record}</span>
            {e.trend>0
              ? <span className="cfb-trend up">▲{e.trend}</span>
              : e.trend<0
                ? <span className="cfb-trend down">▼{Math.abs(e.trend)}</span>
                : <span className="cfb-trend flat">–</span>}
          </li>
        ))}
      </ol>
    </aside>
  );
}

function CFBTab(){
  const [data,setData]       = useState(null);
  const [wk,setWk]           = useState(null);
  const [q,setQ]             = useState('');
  const [showAll,setShowAll] = useState(false);
  const load = (p)=>{
    setData(null);
    const qs = p ? `?week=${p.week}&year=${p.year}&st=${p.st}` : '';
    fetch(`/api/cfb${qs}`).then(r=>r.json())
      .then(d=>{ setData(d&&d.games?d:{week:0,year:0,seasontype:0,games:[]}); if(d&&d.week){setWk({week:d.week,year:d.year,st:d.seasontype});} })
      .catch(()=>setData({week:0,year:0,seasontype:0,games:[]}));
  };
  useEffect(()=>{ load(null); },[]);

  const games  = data ? (data.games||[]) : null;
  const query  = q.trim().toLowerCase();
  const ranked = games ? games.filter(g=>g.ranked) : [];
  let list = [];
  if(games){
    if(query)                         list = games.filter(g=>(g.home||'').toLowerCase().includes(query)||(g.away||'').toLowerCase().includes(query));
    else if(showAll||ranked.length===0) list = games;
    else                              list = ranked;
  }
  const marquee = games ? pickMarquee(games) : null;
  const groups=[]; const gi={};
  list.forEach(g=>{ const k=g.day||'zzz'; if(gi[k]===undefined){gi[k]=groups.length; groups.push({day:k,label:g.day_label||'Date TBD',games:[]});} groups[gi[k]].games.push(g); });
  groups.sort((a,b)=>a.day<b.day?-1:a.day>b.day?1:0);

  return(
    <div className="tab-content">
     <div className="cfb-layout">
      <div className="cfb-main">
      {wk && <div className="cfb-week-nav">
        <button className="date-nav-btn" onClick={()=>load({week:Math.max(1,wk.week-1),year:wk.year,st:wk.st})} disabled={wk.week<=1} style={wk.week<=1?{opacity:.3}:{}}>&lsaquo;</button>
        <span className="cfb-week-label">Week {wk.week}{wk.year?` · ${wk.year}`:''}</span>
        <button className="date-nav-btn" onClick={()=>load({week:wk.week+1,year:wk.year,st:wk.st})}>&rsaquo;</button>
      </div>}

      <div className="cfb-controls">
        <input className="cfb-search" placeholder="Search a team…  (e.g. UCLA)" value={q} onChange={e=>setQ(e.target.value)}/>
        {q && <button className="cfb-clear" onClick={()=>setQ('')}>✕</button>}
        {!query && games && ranked.length>0 && <button className="cfb-toggle" onClick={()=>setShowAll(s=>!s)}>{showAll?'Top 25':`All games (${games.length})`}</button>}
      </div>

      {!games
        ? <div className="loading"><div className="spinner"/></div>
        : <>
            {!query&&<CFBMarquee game={marquee}/>}
            <div className="cfb-head">
              {query ? `Search: “${q}” · ${list.length}`
               : ranked.length===0 ? `All games · ${games.length}  ·  Top 25 posts once the poll is out`
               : showAll ? `All games · ${games.length}`
               : `AP Top 25 · ${ranked.length} game${ranked.length===1?'':'s'}`}
            </div>
            {groups.length
              ? groups.map(grp=>(
                  <div className="cfb-day-group" key={grp.day}>
                    <div className="cfb-day">{grp.label}</div>
                    <div className="game-grid">{grp.games.map(g=><GameCard key={g.id} game={g}/>)}</div>
                  </div>))
              : <div className="cfb-empty">{query ? `No games for “${q}”.` : 'No games scheduled this week.'}</div>}
          </>}
      </div>
      <CFBRankings/>
     </div>
    </div>
  );
}

function LiveNowTab({games,date,setDate}){
  const [sport,setSport]     = useState('all');
  const [showAll,setShowAll] = useState(false);
  if(!games) return <div className="loading"><div className="spinner"/></div>;

  const filterList = list=>sport==='all'?list:list.filter(g=>leagueToFilter(g.league)===sport);
  const live     = filterList(games.filter(g=>g.state==='in'));
  const upcoming = games.filter(g=>g.state==='pre');
  const finished = games.filter(g=>g.state==='post');
  const myLive    = live.filter(g=>g.home_fav||g.away_fav);
  const otherLive = live.filter(g=>!g.home_fav&&!g.away_fav);

  // Up next: sorted by time, first 5
  const upFiltered = filterList(upcoming).sort((a,b)=>{
    if(!a.start_iso&&!b.start_iso) return 0;
    if(!a.start_iso) return 1;
    if(!b.start_iso) return -1;
    return new Date(a.start_iso)-new Date(b.start_iso);
  });
  const visibleUp = showAll ? upFiltered : upFiltered.slice(0,5);

  return(
    <div className="tab-content">
      <div className="date-nav">
        <div className="date-nav-capsule">
          <button className="date-nav-btn" onClick={()=>setDate(d=>shiftDate(d,-1))}>‹</button>
          <span className="date-nav-label">{labelForDate(date)}</span>
          <button className="date-nav-btn" onClick={()=>setDate(d=>shiftDate(d,1))} disabled={date===shiftDate(todayStr(),2)} style={date===shiftDate(todayStr(),2)?{opacity:.3}:{}}>›</button>
        </div>
        {date!==todayStr()&&<button className="date-nav-today" onClick={()=>setDate(todayStr())}>Today</button>}
      </div>
      {date===todayStr()&&<DailySpotlight/>}

      <div className="sport-filter-bar">
        {SPORT_FILTERS.map(f=>(
          <button key={f.key} className={`filter-pill ${sport===f.key?'active':''}`}
            onClick={()=>{setSport(f.key);setShowAll(false);}}>{f.label}</button>
        ))}
      </div>

      {live.length===0&&upFiltered.length===0&&finished.length===0&&(
        <div className="empty day-empty">
          {sport==='all'?'No games scheduled for this day.':`No ${SPORT_FILTERS.find(f=>f.key===sport)?.label||''} games for this day.`}
        </div>
      )}

      {live.length>0&&(
        <section>
          <div className="section-header">
            <h2 className="section-title"><span className="live-indicator"/> Live Now <span className="count-badge">{live.length}</span></h2>
          </div>
          <div className="game-grid">
            {myLive.map(g=><GameCard key={g.id} game={g}/>)}
            {otherLive.map(g=><GameCard key={g.id} game={g}/>)}
          </div>
        </section>
      )}

      {upFiltered.length>0&&<section>
        <div className="section-header">
          <h2 className="section-title">Up Next Today <span className="tz-note">PT</span></h2>
        </div>
        <div className="upcoming-list">
            {visibleUp.map(g=><UpcomingRow key={g.id} game={g}/>)}
          </div>
        {!showAll&&upFiltered.length>5&&(
          <button className="more-btn" onClick={()=>setShowAll(true)}>
            See {upFiltered.length-5} more — sorted by sport →
          </button>
        )}
        {showAll&&upFiltered.length>5&&(
          <>
            <div className="see-all-divider">All games · by sport</div>
            {Object.entries(groupBySport(upFiltered.slice(5))).map(([k,gs])=>(
              <SportSection key={k} sportKey={k} games={gs}/>
            ))}
          </>
        )}
      </section>}

      {finished.length>0&&(
        <section>
          <div className="section-header"><h2 className="section-title">Final Scores</h2></div>
          {Object.entries(groupBySport(filterList(finished))).map(([k,gs])=>(
            <SportSection key={k} sportKey={k} games={gs} cardView/>
          ))}
        </section>
      )}
    </div>
  );
}

// ── Team Panel ────────────────────────────────────────────────────────────────
// ── UFC Fight Summary Modal ───────────────────────────────────────────────────
function UFCFightModal({fight, onClose}){
  if(!fight) return null;
  const Corner = ({name,head,rec,flag,belt,win})=>(
    <div className={`uf-corner ${win?'uf-corner-win':''}`}>
      {head?<img src={head} alt="" className="uf-photo" onError={e=>e.target.style.display='none'}/>:<div className="uf-photo uf-photo-ph">🥊</div>}
      <div className="uf-name">{name}</div>
      {rec&&<div className="uf-rec">{rec}</div>}
      {flag&&<div className="uf-flag">{flag}</div>}
      {belt&&<div className="uf-belt">🏆 {belt}</div>}
      {win&&<div className="uf-wintag">WINNER</div>}
    </div>
  );
  return(
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box uf-modal" onClick={e=>e.stopPropagation()}>
        <div className="uf-modal-head">
          <span className="uf-weight">{fight.weight}{fight.rounds?` · ${fight.rounds} rounds`:''}</span>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="uf-bout-summary">
          <Corner name={fight.fighter1} head={fight.headshot1} rec={fight.record1} flag={fight.flag1} belt={fight.belt1} win={fight.winner1}/>
          <div className="uf-vs-big">VS</div>
          <Corner name={fight.fighter2} head={fight.headshot2} rec={fight.record2} flag={fight.flag2} belt={fight.belt2} win={fight.winner2}/>
        </div>
        {fight.status&&<div className="uf-status">{fight.status}</div>}
      </div>
    </div>
  );
}

function TeamPanel({teamKey, onClose, showClose=true}){
  const colors = TEAM_COLORS[teamKey]||{primary:'#111',secondary:'#d4a427',accent:'#d4a427'};
  const [fightSummary,setFightSummary] = React.useState(null);
  const teamConfig = MY_TEAMS.find(t=>t.key===teamKey);
  const {data:hub,loading} = useFetch(`${API}/team/${teamKey}`,300000);
  const [showSkeleton,setShowSkeleton] = React.useState(true);
  const [currentKey,setCurrentKey] = React.useState(teamKey);
  React.useEffect(()=>{
    setShowSkeleton(true);
    setCurrentKey(teamKey);
    const t = setTimeout(()=>setShowSkeleton(false), 800);
    return ()=>clearTimeout(t);
  },[teamKey]);
  const isLoading = loading || showSkeleton || currentKey !== teamKey;
  const displayHub = isLoading ? null : hub;

  return(
    <div className="team-panel" style={{borderColor:colors.accent}}>
      <div className="team-panel-header" style={{background:colors.primary,borderBottomColor:colors.accent+'44'}}>
        <div style={{display:'flex',alignItems:'center',gap:'12px'}}>
          {displayHub?.games?.[0]?.home_logo&&(
            <img src={displayHub.games[0].home_fav?displayHub.games[0].home_logo:displayHub.games[0].away_logo}
              alt={teamConfig?.name} className="panel-header-logo"/>
          )}
          <div>
            <div className="team-panel-name" style={{color:colors.secondary}}>{teamConfig?.name}</div>
            <div className="panel-header-sub">
              {(()=>{
                if(!displayHub) return null;
                const entries = displayHub.standings ? Object.entries(displayHub.standings) : [];
                if(entries.length>0){
                  const [lName,lData] = entries[0];
                  const group = lData.groups?.[0];
                  const idx = group?.teams?.findIndex(t=>t.fav);
                  const pos = idx!=null&&idx>=0 ? `${idx+1}${['st','nd','rd'][idx]||'th'}` : null;
                  const groupLabel = group?.name ? ` · ${group.name}` : '';
                  return <span style={{color:colors.accent+'99'}}>{lName}{pos?` · ${pos}${groupLabel}`:''}</span>;
                }
                if(!isInSeason(teamConfig?.sport)) return <span style={{color:'#444'}}>Offseason</span>;
                return null;
              })()}
            </div>
          </div>
        </div>
        {showClose&&<button className="panel-close" style={{color:colors.accent}} onClick={onClose}>✕</button>}
      </div>

      {isLoading&&(
        <div className="team-loading">
          <div className="team-loading-bar" style={{background:colors.accent}}/>
          <div className="team-loading-content">
            {[60,40,80,50,70].map((w,i)=>(
              <div key={i} className="team-loading-block" style={{width:w+'%'}}/>
            ))}
          </div>
          <div className="team-loading-label" style={{color:colors.accent}}>
            Loading {teamConfig?.name}...
          </div>
        </div>
      )}

      {!isLoading&&displayHub&&(
        <div className="team-panel-body">

          {/* Games (hidden for UFC — the Fight Card covers it) */}
          {teamKey!=='ufc'&&(
          <div className="panel-section">
            <div className="panel-section-title" style={{color:colors.accent}}>
              {displayHub.games?.some(g=>g.state==='in')?'🔴 Live Now':displayHub.next_label||'Next Game'}
            </div>
            {!displayHub.games||displayHub.games.length===0
              ?<div className="empty">No upcoming games found.</div>
              :<div className="panel-games">
                {displayHub.games.slice(0,3).map(g=><GameCard key={g.id} game={g} compact/>)}
              </div>
            }
          </div>
          )}

          {/* Standings */}
          {displayHub.standings&&Object.keys(displayHub.standings).length>0&&(
            <div className="panel-section">
              <div className="panel-section-title" style={{color:colors.accent}}>Standings</div>
              {Object.entries(displayHub.standings).map(([leagueName,leagueData])=>(
                <div key={leagueName} className="standings-block">
                  <div className="standings-league-row">
                    <span className="standings-league">{leagueName}</span>
                    {leagueData.url&&(
                      <a href={leagueData.url} target="_blank" rel="noreferrer"
                        className="standings-link" style={{color:colors.accent}}>
                        full standings →
                      </a>
                    )}
                  </div>
                  {(leagueData.groups||[]).slice(0,1).map((group,gi)=>(
                    <div key={gi}>
                      {group.name&&<div className="standings-group">{group.name}</div>}
                      <div className="standings-table">
                        {group.teams.slice(0,8).map((team,ti)=>(
                          <div key={ti} className={`standings-row ${team.fav?'standings-fav':''}`}
                            style={team.fav?{borderLeftColor:colors.accent}:{}}>
                            <span className="standings-pos">{ti+1}</span>
                            <span className="standings-team">{team.name}</span>
                            {(team.w!==''&&team.w!=null)&&(
                              <span className="standings-wl">{team.w}-{team.l}{team.gd&&team.gd!==''?` · ${team.gd>0?'+':''}${team.gd}`:''}</span>
                            )}
                            {(team.pts!==''&&team.pts!=null)&&(
                              <span className="standings-pts">{team.pts}<em>pts</em></span>
                            )}
                            {team.gb&&team.gb!=='0'&&team.gb!=='--'&&!(team.pts!==''&&team.pts!=null)&&
                              <span className="standings-gb">{team.gb} back</span>}
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}

          {/* Copa do Brasil note */}
          {displayHub.copa_do_brasil&&(
            <div className="panel-section">
              <div className="panel-section-title" style={{color:colors.accent}}>Copa do Brasil</div>
              <div className="copa-brasil-note">{displayHub.copa_do_brasil}</div>
            </div>
          )}

          {/* UFC full card */}
          {displayHub.ufc_card&&displayHub.ufc_card.length>0&&(
            <div className="panel-section">
              <div className="panel-section-title" style={{color:colors.accent}}>
                {displayHub.ufc_state==='in'?'🔴 Live Card':displayHub.ufc_state==='post'?'Results':displayHub.next_label||'Next Card'}
              </div>
              {displayHub.ufc_event&&(
                <div className="ufc-event-banner">
                  <span className="ufc-event-title">{displayHub.ufc_event}</span>
                  {displayHub.ufc_date&&<span className="ufc-event-date">{displayHub.ufc_date}</span>}
                </div>
              )}
              <div className="ufc-card-list">
                {displayHub.ufc_card.map((f,i)=>(
                  <div key={i} className={`ufc-fight ufc-fight-click ${i===0?'ufc-fight-main':''}`} onClick={()=>setFightSummary(f)}>
                    <div className="ufc-fight-weight">{i===0?'★ Main Event':''}{f.weight?`${i===0?' · ':''}${f.weight}`:''}<span className="ufc-fight-more">details ›</span></div>
                    <div className="ufc-bout">
                      <div className={`ufc-corner ${f.winner1?'ufc-corner-win':''}`}>
                        {f.headshot1
                          ?<img src={f.headshot1} alt="" className="ufc-face" onError={e=>e.target.style.display='none'}/>
                          :<div className="ufc-face ufc-face-ph">🥊</div>}
                        <span className="ufc-name">{f.fighter1}</span>
                      </div>
                      <span className="ufc-vs">vs</span>
                      <div className={`ufc-corner ${f.winner2?'ufc-corner-win':''}`}>
                        {f.headshot2
                          ?<img src={f.headshot2} alt="" className="ufc-face" onError={e=>e.target.style.display='none'}/>
                          :<div className="ufc-face ufc-face-ph">🥊</div>}
                        <span className="ufc-name">{f.fighter2}</span>
                      </div>
                    </div>
                    {f.status&&<div className="ufc-fight-status">{f.status}</div>}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* News */}
          <div className="panel-section">
            <div className="panel-section-title" style={{color:colors.accent}}>Latest News</div>
            {!displayHub.news||displayHub.news.length===0
              ?<div className="empty">No news available.</div>
              :<div className="panel-news">
                {displayHub.news.map((item,i)=>(
                  <a key={i} href={item.link} target="_blank" rel="noreferrer"
                    className="panel-news-item" style={{'--accent':colors.accent}}>
                    <div className="panel-news-title">{item.title}</div>
                    <div className="panel-news-meta">{item.source} · {item.published}</div>
                  </a>
                ))}
              </div>
            }
          </div>
        </div>
      )}
      {fightSummary&&<UFCFightModal fight={fightSummary} onClose={()=>setFightSummary(null)}/>}
    </div>
  );
}


// ── Score celebration ─────────────────────────────────────────────────────────
function classifyScore(sport, dHome, dAway, g, prevDetail){
  const team = dHome>0 ? g.home : g.away;
  const logo = dHome>0 ? g.home_logo : g.away_logo;
  const delta = dHome>0 ? dHome : dAway;
  if(sport==='soccer' && delta>0)
    return {big:'GOAL!', team, logo, color:'#2ecc71', emoji:'⚽'};
  if(sport==='mlb' && delta>0)
    return {big: delta>1?`${delta} RUNS!`:'RUN!', team, logo, color:'#3498db', emoji:'⚾'};
  if((sport==='nfl'||sport==='ncaa') && delta>0){
    const label = delta>=6?'TOUCHDOWN!':delta===3?'FIELD GOAL!':delta===2?'SAFETY!':delta===1?'EXTRA POINT':'SCORE!';
    return {big:label, team, logo, color:'#e67e22', emoji:'🏈'};
  }
  if(sport==='nba'){
    // Basketball scores too often — only celebrate at end of a period.
    const d = (g.detail||'').toLowerCase();
    const wasEnd = (prevDetail||'').toLowerCase().includes('end');
    if((d.includes('end of')||d.includes('halftime'))&&!wasEnd)
      return {big:g.detail, team:`${g.home} ${g.home_score}–${g.away_score} ${g.away}`, logo:null, color:'#9b59b6', emoji:'🏀', small:true};
    return null;
  }
  return null;
}

function ScoreCelebration({event}){
  if(!event) return null;
  return (
    <div className="score-celebration" style={{'--celeb-color':event.color}}>
      <div className={`celeb-card ${event.small?'celeb-small':''} ${event.podium?'celeb-card-podium':''}`}>
        <div className="celeb-emoji">{event.emoji}</div>
        {event.logo&&<img src={event.logo} className="celeb-logo" alt="" onError={e=>e.target.style.display='none'}/>}
        <div className="celeb-big">{event.big}</div>
        {event.podium ? (
          <div className="celeb-podium">
            {event.podium.map((r,i)=>(
              <div key={i} className={`celeb-podium-row celeb-podium-${i+1}`}>
                <span className="celeb-medal">{['🥇','🥈','🥉'][i]}</span>
                <span className="celeb-driver">{r.driver}</span>
                <span className="celeb-pteam">{r.team}</span>
              </div>
            ))}
          </div>
        ) : event.oldScore&&event.newScore ? (
          <div className="celeb-score-change">
            <span className="celeb-shatter">
              <span className="celeb-shatter-half celeb-half-top">{event.oldScore}</span>
              <span className="celeb-shatter-half celeb-half-bot">{event.oldScore}</span>
            </span>
            <span className="celeb-new-score">{event.newScore}</span>
          </div>
        ) : null}
        <div className="celeb-team">{event.team}</div>
      </div>
    </div>
  );
}

// ── Tab: My Teams ─────────────────────────────────────────────────────────────
function MyTeamsTab({games}){
  const [selected,setSelected] = useState('corinthians');

  // Live detection + scores + today's upcoming game
  const liveTeams = new Set();
  const liveScores = {};
  const todayGame  = {};
  (games||[]).filter(g=>g.state==='in').forEach(g=>{
    MY_TEAMS.forEach(t=>{
      const search = t.name.toLowerCase().split('/')[0].trim();
      const nameMatch = g.home?.toLowerCase().includes(search)||g.away?.toLowerCase().includes(search);
      // Prefer backend fav flags, matched by sport, then fall back to name match.
      const favMatch = (g.home_fav||g.away_fav) && leagueToFilter(g.league)===t.sport;
      if(nameMatch||favMatch){
        liveTeams.add(t.key);
        liveScores[t.key] = {
          home: g.home, away: g.away,
          hs: g.home_score, as: g.away_score,
          detail: g.detail,
          homeFav: g.home_fav, awayFav: g.away_fav,
        };
      }
    });
  });
  // Today's upcoming game per team (for sidebar hint)
  (games||[]).filter(g=>g.state==='pre').forEach(g=>{
    MY_TEAMS.forEach(t=>{
      if(todayGame[t.key]) return;
      const search = t.name.toLowerCase().split('/')[0].trim();
      const nameMatch = g.home?.toLowerCase().includes(search)||g.away?.toLowerCase().includes(search);
      const favMatch = (g.home_fav||g.away_fav) && leagueToFilter(g.league)===t.sport;
      if(nameMatch||favMatch) todayGame[t.key] = g.start_time||'Today';
    });
  });

  // Sort: Corinthians first, then in-season, then offseason
  const sortedTeams = [...MY_TEAMS].sort((a,b)=>{
    if(a.key==='corinthians') return -1;
    if(b.key==='corinthians') return 1;
    const aLive = liveTeams.has(a.key)?0:1;
    const bLive = liveTeams.has(b.key)?0:1;
    if(aLive!==bLive) return aLive-bLive;
    const aIn = isInSeason(a.sport)?0:1;
    const bIn = isInSeason(b.sport)?0:1;
    return aIn-bIn;
  });

  return(
    <div className="myteams-layout">
      {/* Sidebar */}
      <div className="teams-sidebar">
        <div className="sidebar-title">My Teams</div>
        {sortedTeams.map(team=>{
          const colors = TEAM_COLORS[team.key]||{accent:'#d4a427',secondary:'#888',badge:'⚽'};
          const isSelected = selected===team.key;
          const isLive = liveTeams.has(team.key);
          const inSeason = isInSeason(team.sport);
          return(
            <div
              key={team.key}
              className={`team-sidebar-item ${isSelected?'team-sidebar-selected':''}`}
              style={isSelected?{borderLeftColor:colors.accent,background:colors.primary+'22'}:{}}
              onClick={()=>setSelected(team.key)}
            >
              {colors.logo
                ?<img src={colors.logo} alt={team.name} className="sidebar-logo" onError={e=>{e.target.style.display='none';}}/>
                :<span className="sidebar-badge">{colors.badge}</span>}
              <div className="sidebar-info">
                <div className="sidebar-name" style={isSelected?{color:colors.secondary}:{}}>{team.name}</div>
                <div className="sidebar-status" style={{color:isLive?'#c0392b':isSelected?colors.accent+'99':'#444'}}>
                  {isLive&&liveScores[team.key]
                    ?<span style={{display:'flex',alignItems:'center',gap:4}}>
                        <span style={{width:5,height:5,borderRadius:'50%',background:'#c0392b',display:'inline-block',animation:'pulse 2s infinite'}}/>
                        <span>{liveScores[team.key].hs}–{liveScores[team.key].as} · {liveScores[team.key].detail}</span>
                      </span>
                    :isLive?<span style={{display:'flex',alignItems:'center',gap:4}}><span style={{width:5,height:5,borderRadius:'50%',background:'#c0392b',display:'inline-block',animation:'pulse 2s infinite'}}/>Live</span>
                    :todayGame[team.key]?`Today · ${todayGame[team.key]}`
                    :inSeason?'In Season':'Offseason'}
                </div>
              </div>
              {isLive&&<span className="sidebar-live-dot"/>}
              {isSelected&&<span className="sidebar-arrow" style={{color:colors.accent}}>›</span>}
            </div>
          );
        })}
      </div>

      {/* Detail panel */}
      <div className="teams-detail">
        {selected&&<TeamPanel teamKey={selected} showClose={false}/>}
      </div>
    </div>
  );
}

// ── App ───────────────────────────────────────────────────────────────────────
export default function App(){
  const [tab,setTabState] = useState(()=>{const h=window.location.hash.replace('#','');return (h==='worldcup'||h==='fantasy')?'live':(h||'live');});
  const setTab = (t)=>{ if(t!==tab) window.location.hash = t; else setTabState(t); };
  useEffect(()=>{
    const onHash=()=>setTabState(window.location.hash.replace('#','')||'live');
    if(!window.location.hash) window.history.replaceState(null,'','#live');
    window.addEventListener('hashchange',onHash);
    return ()=>window.removeEventListener('hashchange',onHash);
  },[]);
  const [soundTestLabel,setSoundTestLabel] = useState('🔊');
  const [date,setDate] = useState(()=>todayStr());
  const isToday = date===todayStr();
  const {data:games,loading} = useFetch(`${API}/games${date&&!isToday?`?date=${date}`:''}`,isToday?60000:300000);
  const {data:live}          = useFetch(`${API}/live`, 60000);
  useEffect(()=>{ if(games) checkScoreChanges(games); },[games]);
  const liveCount = (live||[]).length;

  // Score celebrations
  const prevScoresRef = React.useRef({});
  const fetchPodium = React.useCallback(async(g)=>{
    try{
      const r = await fetch(`${API}/f1/session?session_name=${encodeURIComponent(g.home)}`);
      const d = await r.json();
      const top3 = (d.results||[]).slice(0,3);
      if(top3.length===3){
        setCelebQueue(q=>[...q,{big:'PODIUM', team:g.away, logo:null, color:'#f0c040', emoji:'🏆', podium:top3}]);
      }
    }catch(e){}
  },[]);
  const [celebQueue,setCelebQueue] = useState([]);
  const [currentCeleb,setCurrentCeleb] = useState(null);
  useEffect(()=>{
    if(!games) return;
    const events = [];
    games.forEach(g=>{
      const hs=parseInt(g.home_score)||0, as=parseInt(g.away_score)||0;
      const prev = prevScoresRef.current[g.id];
      if(prev){
        // F1: checkered flag + podium when a Race/Sprint session goes final
        if(g._league_key==='f1' && /race|sprint/i.test(g.home||'') && prev.state==='in' && g.state==='post'){
          events.push({big:'CHECKERED FLAG!', team:`${g.home} · ${g.away}`, logo:null, color:'#e74c3c', emoji:'🏁'});
          fetchPodium(g);
        } else if(g.state==='in'){
          const sport = leagueToFilter(g.league);
          const ev = classifyScore(sport, hs-prev.hs, as-prev.as, g, prev.detail);
          if(ev){
            if(!ev.small){ ev.oldScore=`${prev.hs}\u2013${prev.as}`; ev.newScore=`${hs}\u2013${as}`; }
            events.push(ev);
          }
        }
      }
      prevScoresRef.current[g.id] = {hs, as, detail:g.detail, state:g.state};
    });
    if(events.length) setCelebQueue(q=>[...q,...events]);
  },[games]);
  // Pull the next celebration off the queue when nothing is showing
  useEffect(()=>{
    if(currentCeleb||celebQueue.length===0) return;
    setCurrentCeleb(celebQueue[0]);
    setCelebQueue(q=>q.slice(1));
  },[celebQueue,currentCeleb]);
  // Auto-dismiss the current celebration after its duration
  useEffect(()=>{
    if(!currentCeleb) return;
    const dur = currentCeleb.podium ? 7000 : 5000;
    const t = setTimeout(()=>setCurrentCeleb(null), dur);
    return ()=>clearTimeout(t);
  },[currentCeleb]);

  const TABS=[
    {key:'live',    label:'Live Now',icon:'📺'},
    {key:'myteams', label:'My Teams',icon:'❤️'},
    {key:'cfb',     label:'CFB',     icon:'🏈'},
  ];

  return(
    <div className="app">
      <header className="topbar">
        <div className="logo-area">
          <MaskSmall/>
          <div className="logo-text">
            <span className="logo-main">Majora's Mask</span>
            <span className="logo-sub">Sports Corner</span>
          </div>
          {liveCount>0&&<span className="live-count-badge">{liveCount} live</span>}
        </div>
        <div className="site-nav">
          {SITE_LINKS.map((l,i)=>(
            <React.Fragment key={l.label}>
              {i>0&&<div className="site-nav-sep"/>}
              <a href={l.href} className="site-nav-link">
                <span className="site-nav-icon"><l.Mask/></span>
                <span className="site-nav-label">{l.label}</span>
              </a>
            </React.Fragment>
          ))}
        </div>
        <div className="sound-test-wrap">
          <button className="sound-test-btn" title="Test sounds" onClick={()=>{
            const all = [
              ...GENERIC_WIN_SOUNDS,
              ...GENERIC_LOSE_SOUNDS,
              '/sounds/corinthians/hino-corinthians-cantado.mp3',
              '/sounds/corinthians/qui-fase-que-ta-o-curintia.mp3',
              '/sounds/corinthians/se-o-corinthians-nao-ganhar-ole-ole-ola.mp3',
              '/sounds/corinthians/cropcruzeiro.mp3',
              '/sounds/corinthians/chupaa-palmeras-full.mp3',
              '/sounds/dodgers/baseball-classic-charge-123.mp3',
              '/sounds/dodgers/homerun-baseball.mp3',
              '/sounds/brazil/senna-theme.mp3',
            ];
            const idx = parseInt(localStorage.getItem('sound_test_idx')||'0') % all.length;
            localStorage.setItem('sound_test_idx', idx+1);
            const src = all[idx];
            queueSound(src);
            setSoundTestLabel(src.split('/').pop().replace('.mp3',''));
            clearTimeout(window._soundTestTimer);
            window._soundTestTimer = setTimeout(()=>setSoundTestLabel('🔊'), 2000);
          }}>🔊 {soundTestLabel}</button>
        </div>
        <nav className="nav">
          {TABS.map(t=>(
            <button key={t.key} className={`nav-tab ${tab===t.key?'active':''}`} onClick={()=>setTab(t.key)}>
              <span className="nav-icon">{t.icon}</span>{t.label}
            </button>
          ))}
        </nav>
      </header>

      <ScoreCelebration event={currentCeleb}/>
      <main className={`main ${tab==='myteams'?'main-full':''}`}>
        {loading&&tab==='live'&&<div className="loading"><div className="spinner"/></div>}
        {tab==='live'    &&!loading&&<LiveNowTab games={games} date={date} setDate={setDate}/>}
        {tab==='myteams' &&<MyTeamsTab games={games}/>}
        {tab==='cfb'     &&<CFBTab/>}
      </main>

      <footer className="statusbar">
        <span>majorasmask.us · sports corner</span>
        <span>{new Date().toLocaleTimeString('en-US',{timeZone:'America/Los_Angeles',hour:'numeric',minute:'2-digit',timeZoneName:'short'})}</span>
      </footer>
    </div>
  );
}
